// Single Phaser EventEmitter shared between all Phaser scenes and the React wrapper.
// React components and Phaser scenes both import this module-level singleton.
import Phaser from 'phaser';

import { EVENTS } from './bridgeEvents';

declare global {
	interface Window {
		__bridgeDialogOpen__?: boolean;
		__bridgeEventBus__?: Phaser.Events.EventEmitter;
	}
}

export { EVENTS };

export const EventBus =
	window.__bridgeEventBus__ ?? (window.__bridgeEventBus__ = new Phaser.Events.EventEmitter());

// EventBus events are ephemeral. A Phaser scene that starts after a
// SET_DIALOG_OPEN emit would miss that event and incorrectly allow player
// input. window.__bridgeDialogOpen__ keeps a persistent snapshot that
// BaseRoomScene can read synchronously during create().
export function setBridgeDialogOpenState(open: boolean): void {
	window.__bridgeDialogOpen__ = open;
}

export function getBridgeDialogOpenState(): boolean {
	return window.__bridgeDialogOpen__ ?? false;
}
